import { Module } from 'vuex';
import { loginApi, getUserInfo } from '@/api/system'
import router from '@/router'
import { showToast } from 'vant';
interface authData {
  authentication?: number | undefined;
  onlyCode?: string | undefined;
  tencentSig?: string | undefined;
  token?: string | undefined;
}

const state = {
  authData: {
    authentication: undefined,
    onlyCode: undefined,
    tencentSig: undefined,
    token: undefined,
  },
};

const getters = {
  authData: (state: any) => state.authData,
};

const mutations = {
  setAuthData(state: any, data: authData) {
    state.authData = data;
    //存储到本地
    localStorage.setItem('authData', JSON.stringify(data));
    // 获取用户信息
    mutations.refreshUserInfo(state);
  },
  removeAuthData(state: any) {
    state.authData = {} as authData;
    //删除本地存储
    localStorage.removeItem('authData');
    localStorage.removeItem('userInfo');
    router.replace('/Login');
  },
  refreshUserInfo(state: any) {
    getUserInfo().then(res => {
      //本地存储
      localStorage.setItem('userInfo', JSON.stringify(res.data));
    })
  }
};

const actions = {
  login({ commit }: { commit: any }, data: Record<string, any>) {
    loginApi(data as any).then(res => {
      console.log('登录成功', res)
      if (res.code === 200) {
        commit('setAuthData', res.data);
        // 登录成功后使用路由跳转到首页且不可回退
        router.replace('/')
      } else {
        showToast(res.msg);
      }
    })
  },
  logout({ commit }: { commit: any }) {
    commit('removeAuthData');
  },
  refreshUserInfo({ commit }: { commit: any }) {
    commit('refreshUserInfo');
  }
};

const authModule: Module<any, any> = {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};

export default authModule;